import _ from 'lodash';

import { axios } from './sentryAxios';
import { uuid } from './util';
import { user } from './user';
import { redirectToApplication } from './application';

let seq = 0;

const checkStatus = (response: XMLHttpRequest) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  if (
    response.status === 401 &&
    !_.get(window, 'location.pathname', '').startsWith('/home')
  ) {
    redirectToApplication('USER', '', {
      ref: encodeURIComponent(String(window.location)),
    });
  }

  if (response.status === 0) {
    throw new Error('Network Error');
  }
  throw response;
};

const session = uuid();

let shouldLogRequests = false;

export default class Analytics {
  static enableLogRequests() {
    shouldLogRequests = true;
  }

  static post(url: string, bodyObj: any = {}) {
    return axios.post<any>(url, bodyObj, {
      // 历史逻辑，暂保留
      headers: {
        'Accept': 'application/json;charset=utf-8',
        'Content-Type':  'application/json;charset=utf-8'
      },
      // axios 默认拦截非 status >= 200 && status < 300 请求，这里取消默认设置以便后续 checkStatus
      validateStatus: () => true,
    }).then(res => res.request).then((resp: XMLHttpRequest) => checkStatus(resp))
    .then(resp => JSON.parse(resp.responseText));
  }

  static collect(type: string, obj: any) {
    setTimeout(() => {
      const request: any = {
        session,
        portal: window.__config__.portal,
        location: String(window.location),
        type,
        payload: obj,
      };

      if (user.id) {
        request.user = user.id; // depreciated
        request.userId = user.id;
        request.userGroupId = _.get(user.userGroup, 'userRoleId', '');
        if (user.organization) {
          request.userOrganization = user.organization;
        }
      }

      if (shouldLogRequests) {
        // eslint-disable-next-line no-console
        console.log(request);
      }
    }, 0);
  }

  static collectAction(actionId: string, param: any = {}) {
    ++seq;

    const payload = {
      actionId,
      seq,
      param,
    };

    Analytics.collect('action', payload);
  }

  static publishToAws = _.debounce(() => {
    const body = JSON.parse(localStorage.collected || '[]');
    if (body.length) {
      localStorage.collected = '[]';
      // 不要了，先注释掉
      // fetch(window.__config__.analyticsEndPointUrl, {
      //   method: 'POST',
      //   headers: {
      //     'content-type': 'application/json;charset=utf-8',
      //   },
      //   body: JSON.stringify(body),
      // }).catch(e => {
      //   if (!userTrackingFailEchoSent && enableSentry) {
      //     Sentry.captureException(e);
      //     userTrackingFailEchoSent = true;
      //   }
      // });
    }
  }, 1000);

  static collectToAws(payload: any) {
    if (localStorage) {
      let collected = JSON.parse(localStorage.collected || '[]');
      if (!collected) {
        collected = [];
      }
      collected.push({
        ...payload,
        time: Date.now(),
      });
      localStorage.collected = JSON.stringify(collected);
      Analytics.publishToAws();
    }
  }

  static collectAntUploadeApiResult(url: string, infoFile: any) {
    if (infoFile && infoFile.status === 'done') {
      Analytics.collect('api', {
        url,
        responseCode: infoFile.response.code,
        responseNote: infoFile.response.note,
        status: 200,
        statusText: 'OK',
      });
    }
    if (infoFile && infoFile.status === 'error') {
      Analytics.collect('api', {
        url,
        status: infoFile.error.status,
        fileName: infoFile.name,
      });
    }
  }
}
